import { useProcurifyIntl } from '@webapp/hooks'
import { type IConversationOrderSummaryItem } from './ConversationOrderSummary'
import messages from './messages'
import { ConversationOrderSummaryQuantityCounterStyled } from './styles/ConversationOrderSummaryQuantityCounterStyled'

export interface IConversationOrderSummaryStepperProps {
  item: IConversationOrderSummaryItem
  disabled?: boolean
  isRemoveDisabled?: boolean
  onQuantityChange: (itemId: string, quantity: number) => void
  onRemove: (itemId: string) => void
}

export const ConversationOrderSummaryStepper = ({
  item,
  disabled,
  isRemoveDisabled,
  onQuantityChange,
  onRemove,
}: IConversationOrderSummaryStepperProps) => {
  const intl = useProcurifyIntl()

  const handleChange = (newValue: number) => {
    onQuantityChange(item.id, newValue)
  }

  const handleDelete = () => {
    onRemove(item.id)
  }

  return (
    <ConversationOrderSummaryQuantityCounterStyled
      isValueEditable
      value={item.quantity}
      disabled={disabled}
      isRemoveDisabled={isRemoveDisabled}
      onChange={handleChange}
      onDelete={handleDelete}
      valueInputAriaLabel={intl.formatMessage(messages.quantityAriaLabel, {
        name: item.name,
      })}
      removeButtonAriaLabel={intl.formatMessage(messages.removeItemAriaLabel, {
        name: item.name,
      })}
      decreaseButtonAriaLabel={intl.formatMessage(
        messages.decreaseQuantityAriaLabel,
        { name: item.name }
      )}
      increaseButtonAriaLabel={intl.formatMessage(
        messages.increaseQuantityAriaLabel,
        { name: item.name }
      )}
    />
  )
}
